import { Button } from '#atoms';
import { Modal } from '#molecules';
import { useDashboardChartFormProcess } from '#pages/DashboardChartForm/hooks/useDashboardChartFormProcess';
import { useToast } from '#providers/ToastProvider';
import { useState } from 'react';
import TagManager from 'react-gtm-module';
import styled from 'styled-components';

export const SendButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { send, sendDisabled, finish } = useDashboardChartFormProcess();

  const { showToast } = useToast();

  const onSubmit = () => {
    setIsModalOpen(true);
  };

  const onSend = () => {
    send({
      onSuccess: () => {
        TagManager.dataLayer({
          dataLayer: {
            event: 'exercisechart_new_complete',
            category: '회원관리',
            action: 'exercisechart_new_complete',
            value: 2
          }
        });
        setIsModalOpen(false);
        finish();
        showToast({
          message: '운동차트가 발송되었습니다.',
          type: 'success'
        });
      },
      onError: () => {
        setIsModalOpen(false);
        showToast({
          message: '운동차트 발송에 실패했습니다.',
          type: 'fail'
        });
      }
    });
  };

  return (
    <>
      <div className="px-20 pb-20 fixed bottom-0 w-full max-w-[500px]">
        <Button disabled={sendDisabled} onClick={onSubmit}>
          저장 후 발송
        </Button>
      </div>
      {isModalOpen && (
        <Modal onClose={() => setIsModalOpen(false)}>
          <div className="text-center text-[#d7d2de] text-xl font-semibold font-['Pretendard Variable'] leading-normal tracking-tight">
            운동차트를 저장하고
            <br />
            회원님께 바로 발송합니다.
          </div>
          <div className="text-center text-[#938f9e] text-base font-normal font-['Pretendard Variable'] leading-[21px]">
            발송한 후에는 수정이 불가능해요!
            <br />
            바로 발송하시겠어요?
          </div>
          <div className="flex w-full gap-12 mt-20">
            <StyledButton
              buttonType="cancle"
              onClick={() => setIsModalOpen(false)}
            >
              이전으로
            </StyledButton>
            <StyledButton buttonType="confirm" onClick={onSend}>
              확인
            </StyledButton>
          </div>
        </Modal>
      )}
    </>
  );
};

const StyledButton = styled.button<{ buttonType: 'confirm' | 'cancle' }>`
  display: flex;
  padding: 12px 40px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  border-radius: 8px;

  background: ${({ buttonType }) =>
    buttonType === 'confirm'
      ? 'var(--Brand-400, #7750e9)'
      : 'var(--bg-600, #2e2a3a)'};

  color: ${({ buttonType }) =>
    buttonType === 'confirm'
      ? 'var(--Gray-Scale-100, #EBE9F4)'
      : 'var(--Gray-Scale-400, #bcb8c3)'};

  /* NEW/body_02_medium */
  font-family: 'Pretendard Variable';
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px; /* 131.25% */
  letter-spacing: -0.32px;
  white-space: nowrap;
`;
